export default __webpack_public_path__ + "static/media/zivot.1d31a754.svg";